<template>
  <v-row>
    <v-col>
      <v-card :class="$vuetify.breakpoint.xsOnly ? 'pa-4' : 'px-3 py-6'">
        <div class="title mb-4">
          การเห็นชอบ/อนุญาต
        </div>

        <div class="pl-2">
          <div v-if="statusLists.length > 0" class="mb-2">
            <div class="mb-1 ">เลือกสถานะ</div>
            <v-radio-group v-model="form.ApproveStatusID" class="ma-0 " hide-details="auto">
              <v-radio
                v-for="(item, index) in statusLists"
                :key="index"
                :label="item.approveStatusName"
                :value="item.approveStatusID"
                @change="onChangeApproveStatus(item)"
              />
            </v-radio-group>
          </div>

          <div v-if="form.SendStatus" class="mb-4">
            <leave-search-employee
              :selected-employee="form.SendEmployeeID"
              :selected-employee-title="`เลือกผู้ส่งต่อ`"
              :selected-employee-name="form[`SendEmployeeName${$lang}`]"
              :list="keywordSearchList"
              :no-search="!form.SendChangeEmpStatus"
              :isload="searchLoading"
              @search="onSearchEmpApprove"
              @select="onSelectApprover"
            />
          </div>

          <div class="mb-4">
            <v-textarea v-model="form.Description" label="เหตุผล" hide-details="auto" outlined dense />
          </div>

          <div class="mb-4">
            <v-text-field label="ผู้พิจารณา" hide-details="auto" :value="$username" disabled outlined dense />
          </div>

          <div class="mb-1 mr-3">
            <v-row justify="end">
              <v-btn class="mr-2 mb-2" color="secondary" to="/leave/approve" depressed>
                กลับหน้ารายการ
              </v-btn>
              <v-btn
                class="mr-2"
                color="primary darken-2"
                :disabled="submitLoading || !form.ApproveStatusID || !form.SendEmployeeID"
                depressed
                @click="onSubmit"
              >
                <v-progress-circular
                  v-if="submitLoading"
                  class="mr-2"
                  color="white"
                  width="2"
                  size="24"
                  indeterminate
                />

                บันทึกข้อมูล
              </v-btn>
            </v-row>
          </div>
        </div>
      </v-card>
    </v-col>
  </v-row>
</template>

<script>
import LeaveSearchEmployee from '@/components/leave/LeaveForm/LeaveSearchEmployee';

export default {
  components: {
    LeaveSearchEmployee
  },

  props: {
    approveNumber: {
      type: Number,
      default: 1
    }
  },

  data() {
    return {
      searchLoading: false,
      submitLoading: false,
      statusLists: [],
      keyword: '',
      keywordSearchList: [],
      form: {
        LeaveOrderID: this.$route.params.leaveOrderID,
        ApproveNumber: this.approveNumber,
        LeaveEmployeeID: this.$guid,
        ApproveStatusID: '',
        SendStatus: false,
        SendChangeEmpStatus: true,
        SendEmployeeID: 'P',
        SendEmployeeNameTha: '',
        SendEmployeeNameEng: '',
        Description: ''
      }
    };
  },

  async mounted() {
    this.form.LeaveOrderID = this.$route.params.leaveOrderId;
    this.form.LeaveEmployeeID = this.$guid;

    this.statusLists = await this.apiGetApproveStatusList();

    const defaultInfo = this.statusLists.length > 0 ? this.statusLists[0] : null;
    //console.log(defaultInfo);
    if (defaultInfo) {
      // this.form.ApproveStatusID = defaultInfo.approveStatusID
      this.form.SendStatus = defaultInfo.sendStatus;
      this.form.SendChangeEmpStatus = defaultInfo.sendChangeEmpStatus;
      this.form.SendEmployeeID = defaultInfo.defaultSendEmployeeID;
      this.form.SendEmployeeNameTha = defaultInfo.defaultSendEmployeeNameTha;
      this.form.SendEmployeeNameEng = defaultInfo.defaultSendEmployeeNameEng;
    }
  },

  methods: {
    onChangeApproveStatus(item) {
      this.form.SendStatus = item.sendStatus;
      this.form.SendChangeEmpStatus = item.sendChangeEmpStatus;
      this.form.SendEmployeeID = item.defaultSendEmployeeID;
      this.form.SendEmployeeNameTha = item.defaultSendEmployeeNameTha;
      this.form.SendEmployeeNameEng = item.defaultSendEmployeeNameEng;
      this.form.Description = item.defaultMessage;
    },

    async onSearchEmpApprove(keyword) {
      this.keyword = keyword;
      if (this.keyword.length > 1) {
        this.keywordSearchList = await this.apiPostSearchEmployeeByKeyword();
      }
    },

    onSelectApprover(item) {
      this.form.SendEmployeeID = item.employeeID;
      this.form.SendEmployeeNameTha = item.employeeNameTha;
      this.form.SendEmployeeNameEng = item.employeeNameEng;
    },

    async onSubmit() {
      this.submitLoading = await true;
      await this.apiPostCreateApproval();
      this.submitLoading = false;
      this.$router.push('/leave/approve');
    },

    async apiGetApproveStatusList() {
      try {
        const payload = {
          leaveOrderId: this.$route.params.leaveOrderId,
          approveNumber: this.approveNumber
        };
        const res = await this.$store.dispatch('leave/getApproveStatusList', payload);
        return res.data?.data || [];
      } catch (e) {
        console.log(e.response || e);
      }
    },

    async apiPostSearchEmployeeByKeyword() {
      this.searchLoading = true;
      const body = {
        Keyword: this.keyword
      };
      try {
        const res = await this.$store.dispatch('leave/postSearchEmployeeByKeyword', body);
        return res.data?.data || [];
      } catch (e) {
        console.log(e.response || e);
      } finally {
        this.searchLoading = false;
      }
    },

    async apiPostCreateApproval() {
      if (this.submitLoading) {
        try {
          let res = await this.$store.dispatch('leave/postCreateApproval', this.form);
          return res;
        } catch (e) {
          console.log(e.response || e);
        }
      }
    }
  }
};
</script>

<style lang="scss" scoped></style>
